import { SvgIcon } from '@mui/material';
import { IconProps } from './types/iconTypes';
const ArrowRightIcon = ({
  color = '$neutrals-700',
  width = '24',
  height = '24',
  className
}: IconProps) => <SvgIcon sx={{
  transform: 'rotate(180deg)'
}} className={className} width={`${width}px`} height={`${height}px`} viewBox={`0 0 ${width} ${height}`} data-sentry-element="SvgIcon" data-sentry-component="ArrowRightIcon" data-sentry-source-file="ArrowRightIcon.tsx">
		<path d="M15.41 7.41L14 6L8 12L14 18L15.41 16.59L10.83 12L15.41 7.41Z" fill={color} data-sentry-element="path" data-sentry-source-file="ArrowRightIcon.tsx" />
	</SvgIcon>;
export default ArrowRightIcon;